import { authHeaders, fetchWithAuthRetry, getApiUrl, parseApiError } from './common';

/** ALL이면 프로젝트의 모든 알림, PERSONAL이면 나와 직접 관련된 알림만 받는다. */
export type NotificationScopeMode = 'ALL' | 'PERSONAL';

/**
 * 멤버 계정 전역 알림 규칙. 프로젝트별 알림 유형 on/off(NotificationPreference)와 별개로
 * 모든 프로젝트에 공통 적용된다.
 * - workDays: 0=일 ~ 6=토
 * - startMinute / endMinute: 자정 기준 분(0~1439)
 * - timezone: IANA 타임존 이름
 */
export type NotificationSettings = {
  scopeMode: NotificationScopeMode;
  workScheduleEnabled: boolean;
  workDays: number[];
  startMinute: number;
  endMinute: number;
  timezone: string;
};

/** 부분 저장. 전달하지 않은 필드는 서버에 저장된 값을 그대로 유지한다. */
export type NotificationSettingsPatch = Partial<NotificationSettings>;

type NotificationSettingsResponse = {
  data: NotificationSettings;
};

export const getNotificationSettings = async (token: string): Promise<NotificationSettings> => {
  const response = await fetchWithAuthRetry(`${getApiUrl()}/api/notifications/settings`, {
    cache: 'no-store',
    headers: authHeaders(token),
  });

  if (!response.ok) {
    throw await parseApiError(response, `Failed to fetch notification settings: ${response.status}`);
  }

  const data = (await response.json()) as NotificationSettingsResponse;
  return data.data;
};

export const updateNotificationSettings = async (
  token: string,
  patch: NotificationSettingsPatch,
): Promise<NotificationSettings> => {
  const response = await fetchWithAuthRetry(`${getApiUrl()}/api/notifications/settings`, {
    method: 'PUT',
    headers: authHeaders(token, true),
    body: JSON.stringify(patch),
  });

  if (!response.ok) {
    throw await parseApiError(response, `Failed to update notification settings: ${response.status}`);
  }

  const data = (await response.json()) as NotificationSettingsResponse;
  return data.data;
};
